import { put, fork, call, select, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { formatterMonth } from '../../utils/formatters';
import { loadSaleOrderCompletion } from '../../actions';

export function* watchLoadSaleOrderList() {
  yield takeEvery('LOAD_SALE_ORDER', function*({ willReload }) {
    const { list, query } = yield select(
      state => state.member.saleOrder.master
    );
    const date = formatterMonth(query.time);

    let start = 0;
    if (!willReload && list) {
      start = list.length;
    }

    const options = {
      url: `/api/order/sales?start=${start}&size=${query.size}&startTime=${date.startTime}&endTime=${date.endTime}&keyword=${query.keyword}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadSaleOrderCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

export default function* saleOrderSaga() {
  yield all([fork(watchLoadSaleOrderList)]);
}
